<template>
  <div>
    <b-button variant="outline-light" v-on:click="detayaGit()"
      ><Icon
        icon="akar-icons:search"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'DETAY'"
        color="#7367F0"
    /></b-button>
    <b-modal
      ref="modal-secimYap"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Reçete"
      size="xl"
      hide-footer
      :clickToClose="false"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div>
          <vs-card>
            <div slot="header" style="height: 25px;">
              <h6>
                Ürün
              </h6>
            </div>

            <b-row>
              <b-col cols="12"> </b-col>
              <b-col cols="12"> </b-col>

              <b-col cols="12">
                <b-row>
                  <b-col cols="5">
                    <p style="text-align: center">Ürün</p>
                  </b-col>
                  <b-col cols="2">
                    <p style="text-align: center">Adet</p>
                  </b-col>

                  <b-col cols="3">
                    <p style="text-align: center">Depo</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <!-- Item Name -->
                  <b-col cols="5">
                    <b-row>
                      <b-col cols="2"> </b-col>
                      <b-col>
                        <b-form-input
                          v-model="ANASTOCKNAME"
                          style="font-size: inherit"
                          id="cost"
                          type="text"
                          placeholder="Stok Adı"
                          disabled
                        />
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="2">
                    <b-form-group label-for="cost">
                      <b-form-input
                        v-model="ANAQUANTITY"
                        style="font-size: inherit"
                        id="cost"
                        type="text"
                        placeholder="Adet"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <v-select
                      v-model="ANADEPO"
                      :options="ANADEPOOPTION"
                      label="DESCRIPTION"
                      autocomplete
                      size="small"
                    >
                    </v-select>
                  </b-col>

                  <!-- Quantity -->

                  <!-- Remove Button -->

                  <b-col cols="12" style="height: 5px"> </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- Row Loop -->
          </vs-card>
          <vs-card v-if="receteListValidate == true">
            <div slot="header" style="height: 25px;">
              <h6>
                Kullanılacak Malzeme
              </h6>
            </div>
            <div
              ref="form"
              class="repeater-form"
              @submit.prevent="repeateAgain"
            >
              <!-- Row Loop -->
              <b-form ref="form" @submit.prevent="repeateAgain">
                <b-row>
                  <b-col cols="12"> </b-col>
                  <b-col cols="12"> </b-col>

                  <b-col cols="12">
                    <b-row>
                      <b-col cols="5">
                        <p style="text-align: center">Ürün</p>
                      </b-col>
                      <b-col cols="2">
                        <p style="text-align: center">Birim</p>
                      </b-col>
                      <b-col cols="2">
                        <p style="text-align: center">Depo</p>
                      </b-col>

                      <b-col cols="1">
                        <p style="text-align: center">Adet 1</p>
                      </b-col>
                      <b-col cols="1">
                        <p style="text-align: center">Adet 2</p>
                      </b-col>

                      <b-col cols="1"> </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12">
                    <div :class="scrollview" style="padding-right: 10px;">
                      <b-row
                        v-for="(item, index) in items"
                        :id="item.id"
                        :key="item.id"
                        ref="row"
                      >
                        <!-- Item Name -->

                        <b-col cols="5">
                          <b-row>
                            <b-col cols="2">
                              <div
                                :class="{ activeLoading: activeLoading }"
                                :id="[`button-with-loading-yeni2`]"
                                style="width: 30px; height: 30px;"
                                class="vs-con-loading__container "
                              ></div>
                            </b-col>
                            <b-col cols="10" align-self="center">
                              <b-form-group label-for="cost">
                                <vue-autosuggest
                                  v-if="item.disabled == false"
                                  v-model="stokListInputMix"
                                  style="width: 100%"
                                  :suggestions="filteredOptions3"
                                  :get-suggestion-value="getSuggestionValue"
                                  @click="clickHandler(index)"
                                  :input-props="{
                                    id: 'autosuggest__input',
                                    class: 'form-control'
                                  }"
                                  @input="getStokListMix"
                                >
                                  <template slot-scope="{ suggestion }">
                                    <div
                                      class="d-flex align-items-center my-suggestion-item "
                                    >
                                      <div
                                        class="detail ml-50 my-suggestion-item"
                                      >
                                        <b-card-text class="mb-0">
                                          {{ suggestion.item.STOCKNO }} /
                                          {{ suggestion.item.STOCKNAME }}
                                        </b-card-text>
                                      </div>
                                    </div>
                                  </template>
                                </vue-autosuggest>

                                <v-select
                                  v-else
                                  v-model="item.MIXSTOCKNAME"
                                  :options="stokListesi"
                                  label="STOCKNAME"
                                  autocomplete
                                  size="small"
                                  disabled
                                >
                                </v-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col cols="2" style="padding-right: 0">
                          <b-form-group label-for="cost">
                            <v-select
                              v-model="item.MIXSTOCKUNIT"
                              :options="ANAUNITOPTION"
                              label="DESCRIPTION"
                              autocomplete
                              size="small"
                              :disabled="item.disabled"
                            >
                            </v-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="2" style="padding-right: 0">
                          <v-select
                            v-model="item.MIXDEPOTID"
                            :options="ANADEPOOPTION"
                            label="DESCRIPTION"
                            autocomplete
                            size="small"
                            :disabled="item.disabled"
                          >
                          </v-select>
                        </b-col>
                        <b-col cols="1" style="padding-right: 0">
                          <b-form-group label-for="cost">
                            <b-form-input
                              v-model="item.MIXQUANTITY"
                              style="font-size: inherit"
                              id="cost"
                              type="text"
                              placeholder="Adet 1"
                              :disabled="item.disabled"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col cols="1" style="padding-right: 0">
                          <b-form-group label-for="cost">
                            <b-form-input
                              v-model="item.MIXQUANTITY2"
                              style="font-size: inherit"
                              id="cost"
                              type="text"
                              placeholder="Adet 2"
                              :disabled="item.disabled"
                            />
                          </b-form-group>
                        </b-col>

                        <!-- Quantity -->

                        <b-col
                          style="padding-right: 0"
                          cols="1"
                          class="mb-50"
                          v-if="item.disabled == false"
                        >
                          <b-row style="padding: 0">
                            <b-col style="padding: 0">
                              <b-button
                                variant="outline-light"
                                size="sm"
                                v-on:click="addRecete(index)"
                                ><Icon
                                  color="#28c76f"
                                  icon="ic:baseline-save-all"
                                  width="20"
                                  height="20"
                              /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col cols="1" class="mb-50" v-else>
                          <b-row style="padding: 0">
                            <b-col style="padding: 0">
                              <b-button
                                variant="outline-light"
                                size="sm"
                                v-on:click="removeRecete(index)"
                                ><Icon
                                  color="#EA5455"
                                  icon="ic:baseline-remove-circle"
                                  width="20"
                                  height="20"
                              /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                        <!-- Remove Button -->
                        <b-col cols="12" style="height: 5px"> </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <!-- Row Loop -->
              </b-form>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <b-button
                  style="background-color: #28C76F; border-color:#28C76F;"
                  v-on:click="receteKaydet(items.length)"
                  ><Icon
                    style="margin-right: 5px"
                    icon="mdi:content-save-check-outline"
                    width="20"
                    height="20"
                    v-b-tooltip.hover.bottom="'Reçete kaydet'"
                  />Kaydet</b-button
                >
              </vs-row>
            </div>
          </vs-card>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import state from "../../../../store/state";
import Store from "../../../../store/store";
export default {
  props: ["stokList"],
  data() {
    return {
      secilenStokIndex: "",
      stokListInputMix: "",
      indKontrol: "",
      stokListesi: [],
      itemIndex: 1,
      ANAQUANTITY: "",
      ANADEPO: "",
      ANAUNIT: "",
      ANADEPOOPTION: [],
      ANAUNITOPTION: [],
      scrollview: "",
      activeLoading: false,
      types: ["material", "material"],
      girilenStok: "",
      filteredOptions3: [],
      stokListInput: [],
      secilenStok: [],
      receteListValidate: false,
      ANASTOCKNAME: "",

      items: [
        {
          id: 1,
          MIXSTOCKNAME: "",
          COMPANYID: "",
          STOCKID: "",
          STOCKNAME: "",
          DEPOTID: false,
          QUANTITY: "",
          MIXSTOCKID: "",
          MIXSTOCKUNIT: "",
          MIXDEPOTID: "",
          MIXQUANTITY: "",
          MIXQUANTITY2: "",
          disabled: false
        }
      ]
    };
  },

  components: { Icon, "v-select": vSelect },
  methods: {
    clickHandler(index) {
      this.secilenStokIndex = index;
      
      this.$vs.loading({
        color: "danger",
        container: "#button-with-loading-yeni2",
        scale: 0.45
      });
      this.getStokList();
    },
    receteKaydet(index) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (vm.ANADEPO == "") {
        vs.notify({
          title: "Reçete Kaydet",
          text: "Ana depo seçilmedi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.ANAQUANTITY == "") {
        vs.notify({
          title: "Reçete Kaydet",
          text: "Stok adedi seçilmedi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        vm.items.forEach((val, index) => {
          if (val.disabled == true) {
            const args = {
              COMPANYID: state.MusteriId,
              ARANAN: "",
              ISLEM: "",
              token: Store.state.tokenId,
              STOCKID: vm.params.data.STOCKID,
              DEPOTID: vm.ANADEPO.CODE,
              QUANTITY: vm.ANAQUANTITY,
              MIXSTOCKID: val.MIXSTOCKNAME.STOCKID,
              MIXSTOCKUNIT: val.MIXSTOCKUNIT.CODE,
              MIXDEPOTID: val.MIXDEPOTID.CODE,
              MIXQUANTITY: val.MIXQUANTITY,
              MIXQUANTITY2: val.MIXQUANTITY2,
              MIXSTOCKNAME: val.MIXSTOCKNAME.STOCKNAME,
              ITEMNO: index,
              INSERTUSERID: Store.state.UserId
            };
            soap.createClient(url, function(err, client) {
              client.STOCKMIXISLEMT(args, function(err, result) {
                if (result.STOCKMIXISLEMTResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                vm.veriler = JSON.parse(result.STOCKMIXISLEMTResult);
                try {
                  if (vm.veriler.response == "Ok") {
                    vs.notify({
                      title: "Reçete Kayıt",
                      text: vm.veriler.message,
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "success",
                      position: "top-center"
                    });
                    vm.ANADEPO = "";
                    vm.ANAQUANTITY = "";
                    vm.items = [
                      {
                        id: 1,
                        COMPANYID: "",
                        STOCKID: "",
                        STOCKNAME: "",
                        DEPOTID: "",
                        QUANTITY: "",
                        MIXSTOCKNAME: "",
                        MIXSTOCKID: "",
                        MIXSTOCKUNIT: "",
                        MIXDEPOTID: "",
                        MIXQUANTITY: "",
                        MIXQUANTITY2: "",
                        disabled: false
                      }
                    ];
                    vm.getReceteList();
                    vm.$root.$emit("getStokListForRecete");
                  } else {
                    vs.notify({
                      title: "Reçete Kayıt",
                      text: vm.veriler.message,
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "warning",
                      position: "top-center"
                    });
                  }
                } catch (error) {
                  vs.notify({
                    title: "Reçete Kayıt",
                    text: "Beklenmedik Hata",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center"
                  });
                }
              });
            });
          }
        });
      }
    },
    removeRecete(index) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (
        vm.items[index].STOCKID == "" ||
        typeof vm.items[index].STOCKID == "undefined"
      ) {
        vm.items.splice(index, 1);
      } else {
        const args = {
          STOCKID: vm.items[index].STOCKID,
          MIXSTOCKID: vm.items[index].MIXSTOCKID,
          token: Store.state.tokenId,
          ISLEM: "DEL"
        };
        soap.createClient(url, function(err, client) {
          client.STOCKMIXISLEMT(args, function(err, result) {
            if (result.STOCKMIXISLEMTResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.STOCKMIXISLEMTResult);
              vm.getReceteList();
              vm.$root.$emit("getStokListForRecete");
            } catch (error) {}
          });
        });
      }
    },
    repeateAgain() {
      this.itemIndex++;
      this.items.push({
        id: this.itemIndex,
        disabled: false
      });
    },
    getTanimList(tanim) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        COMPANYID: state.MusteriId,
        ROOT: tanim == "UNIT" || tanim == "DEPOTID" ? "" : "VE_STOCK",
        ROOTFIELD: tanim
      };
      soap.createClient(url, function(err, client) {
        client.TANIMLIST(args, function(err, result) {
          if (result.TANIMLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.TANIMLISTResult);
          if (tanim == "DEPOTID") vm.ANADEPOOPTION = vm.veriler;
          else if (tanim == "UNIT") vm.ANAUNITOPTION = vm.veriler;
        });
      });
    },
    getReceteList() {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        ARANAN:
          vm.params.data.STOCKNO.trim() == ""
            ? vm.params.data.STOCKNAME
            : vm.params.data.STOCKNO
      };
      soap.createClient(url, function(err, client) {
        client.STOCKMIXLIST(args, function(err, result) {
          if (result.STOCKMIXLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKMIXLISTResult);
          try {
            if (vm.veriler.response == "Ok") {
              let receteList = JSON.parse(vm.veriler.jsonData);
              vm.receteListValidate = true;
              vm.items = [
                {
                  id: 1,
                  COMPANYID: "",
                  STOCKID: "",
                  STOCKNAME: "",
                  DEPOTID: "",
                  QUANTITY: "",
                  MIXSTOCKNAME: "",
                  MIXSTOCKID: "",
                  MIXSTOCKUNIT: "",
                  MIXDEPOTID: "",
                  MIXQUANTITY: "",
                  MIXQUANTITY2: "",
                  disabled: false
                }
              ];
              if (receteList.length > 0) {
                vm.ANAQUANTITY = receteList[0].QUANTITY;
                vm.ANADEPO = {
                  CODE: receteList[0].DEPOTID,
                  DESCRIPTION: receteList[0].DEPOTIDDESC
                };

                receteList.forEach((val, index) => {
                  vm.itemIndex++;
                  vm.items.push({
                    id: vm.itemIndex,
                    COMPANYID: val.COMPANYID,
                    STOCKID: val.STOCKID,
                    STOCKNAME: val.STOCKNAME,
                    DEPOTID: val.DEPOTID,
                    QUANTITY: val.QUANTITY,
                    MIXSTOCKID: val.MIXSTOCKID,
                    MIXSTOCKUNIT: {
                      CODE: val.MIXSTOCKUNIT,
                      DESCRIPTION: val.MIXSTOCKUNITDESC
                    },
                    MIXSTOCKNAME: {
                      STOCKNAME: val.MIXSTOCKNAME,
                      STOCKID: val.MIXSTOCKID
                    },
                    MIXDEPOTID: {
                      CODE: val.MIXDEPOTID,
                      DESCRIPTION: val.MIXDEPOTIDDESC
                    },
                    MIXQUANTITY: val.MIXQUANTITY,
                    MIXQUANTITY2: val.MIXQUANTITY2,
                    disabled: true
                  });
                });
              }
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            console.log(error);
            vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    addRecete(index) {
      var vm = this;
      var vs = this.$vs;
      if (vm.items[index].MIXSTOCKNAME == "") {
        vs.notify({
          title: "Reçete Ekle",
          text: "Stok bilgisi seçilmedi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.items[index].MIXSTOCKUNIT == "") {
        vs.notify({
          title: "Reçete Ekle",
          text: "Stok birimi seçilmedi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.items[index].MIXDEPOTID == "") {
        vs.notify({
          title: "Reçete Ekle",
          text: "Stok deposu seçilmedi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.items[index].MIXQUANTITY == "") {
        vs.notify({
          title: "Reçete Ekle",
          text: "Stok adedi seçilmedi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        vm.items[index].disabled = true;
        vm.indKontrol = index;
        vm.repeateAgain();
        vm.getStokList();
      }
    },
    getSuggestionValue(suggestion) {
      this.secilenStok = suggestion.item;
      this.items[this.secilenStokIndex].MIXSTOCKNAME = suggestion.item;
      return suggestion.item.STOCKNO + "/" + suggestion.item.STOCKNAME;
    },
    changedVal(val) {
      this.girilenStok = val.srcElement._value;
    },
    detayaGit() {
      try {
        this.$refs["modal-secimYap"].show();
        this.ANASTOCKNAME = this.params.data.STOCKNAME;
        this.getReceteList();
        this.getTanimList("DEPOTID");
        this.getTanimList("UNIT");
      } catch (error) {
        console.log(error);
      }
    },
    getStokListMix() {
      let type = "material";

      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      let args = {};

      vm.filteredOptions3 = [
        {
          data: vm.stokListesi.filter(option => {
            return (
              option.STOCKNO.toLowerCase().indexOf(vm.stokListInputMix.toLowerCase()) > -1 ||
              option.STOCKNAME.toLowerCase().indexOf(vm.stokListInputMix.toLowerCase()) > -1
            );
          })
        }
      ];

    },
    getStokList() {
      let type = "material";

      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        COMPANYID: state.MusteriId,
        ARANAN: vm.stokListInput,
        ISLEM: "LIST",
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.STOCKLISTFORMIX(args, function(err, result) {
          if (result.STOCKLISTFORMIXResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKLISTFORMIXResult);

          vm.stokListesi = JSON.parse(vm.veriler.jsonData);

          setTimeout(() => {
            vs.loading.close("#button-with-loading-yeni2 > .con-vs-loading");
          }, 1000);
          vm.filteredOptions3 = [
            {
              data: vm.stokListesi.filter(option => {
                return (
                  option.STOCKNO.toLowerCase().indexOf(vm.stokListInputMix) >
                    -1 ||
                  option.STOCKNAME.toLowerCase().indexOf(vm.stokListInputMix) >
                    -1
                );
              })
            }
          ];
        });
      });
    }
  },
  created() {
    this.scrollview = "scroll-hand";
  }
};
</script>
<style lang="scss">
.scroll-hand {
  min-height: 250px;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
}
.fill-row-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  .loading-example {
    width: 120px;
    float: left;
    height: 120px;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    margin: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
      transform: translate(0, 4px);
    }
    h4 {
      z-index: 40000;
      position: relative;
      text-align: center;
      padding: 10px;
    }
    &.activeLoading {
      opacity: 0 !important;
      transform: scale(0.5);
    }
  }
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
  z-index: 11111111111;
}
[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}
[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}
.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 1000000111111111111111111;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 200px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}

[dir] #autosuggest__input {
  padding: 5px;
}
.vs-card--header {
  height: 25px !important;
}
</style>
